import {
  GET_DATA_SETS_SUCCESS,
  GET_DATA_SETS_FAILURE,
  GET_DATA_SET_SUCCESS,
  GET_DATA_SETS_SUMMARY_SUCCESS,
  GET_DATA_SETS_SUMMARY_FAILURE,
  GET_DATA_SET_SUMMARY_SUCCESS,
  GET_DATA_SET_UPDATE_TIME_SUCCESS,
  GET_DATA_SET_DOC_SUCCESS,
  UPDATE_DATA_SET_DOC_SUCCESS,
  DELETE_DATASET_SUCCESS,
  DELETE_PIPELINE_SUCCESS,
  ADD_DATASET_FAILURE,
  ADD_DATASET_SUCCESS,
  COPY_DATA_SET_SUCCESS,
  COPY_DATA_SET_FAILURE,
  COPY_DATA_SET_TO_CLIPBOARD,
  LOGOUT_COMPLETE,
} from '../../constants/actionTypes';

import map from 'lodash/map';
import filter from 'lodash/filter';
import reduce from 'lodash/reduce';
import forEach from 'lodash/forEach';
import has from 'lodash/has';
import indexOf from 'lodash/indexOf';
import isEmpty from 'lodash/isEmpty';

const initialState = {
  lastUpdated: null,
  byId: [],
  summaryById: {},
  sampleUpdateTimeById: {},
  docById: {},
  lastAddedId: null,
  clipboardDatasetId: null,
  error: null,
};

export const dataSetsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DATA_SETS_SUCCESS:
      return saveDatasets(state, action);

    case GET_DATA_SET_SUCCESS:
      return saveDataset(state, action);

    case GET_DATA_SETS_FAILURE:
      return removeDataset(state, action);

    case GET_DATA_SETS_SUMMARY_SUCCESS:
      return saveDatasetsSummary(state, action);

    case GET_DATA_SET_SUMMARY_SUCCESS:
      return saveDatasetSummary(state, action);

    case GET_DATA_SETS_SUMMARY_FAILURE:
      return {
        ...state,
        summaryById: {},
      };

    case GET_DATA_SET_UPDATE_TIME_SUCCESS:
      return saveDatasetUpdateTime(state, action);

    case GET_DATA_SET_DOC_SUCCESS:
    case UPDATE_DATA_SET_DOC_SUCCESS:
      return saveDatasetDoc(state, action);

    case DELETE_DATASET_SUCCESS:
      return deleteDataset(state, action);

    case DELETE_PIPELINE_SUCCESS:
      return deletePipeline(state, action);

    case ADD_DATASET_SUCCESS:
    case COPY_DATA_SET_SUCCESS:
      return addDataset(state, action);

    case COPY_DATA_SET_TO_CLIPBOARD:
      return copyDatasetToClipboard(state, action);

    case LOGOUT_COMPLETE:
      return initialState;

    case ADD_DATASET_FAILURE:
    case COPY_DATA_SET_FAILURE:
    default:
      return state;
  }
};

export default dataSetsReducer;

function saveDatasets(state, action) {
  const { result } = action;
  //all Nexsets. split into source and derived

  return {
    ...state,
    lastUpdated: action.receivedAt,
    byId: result,
    error: null,
  };
}

function saveDataset(state, action) {
  const dataSetId = action.result;

  return {
    ...state,
    lastUpdated: action.receivedAt,
    byId: indexOf(state.byId, dataSetId) === -1 ? [dataSetId, ...state.byId] : [...state.byId],
    error: null,
  };
}

function addDataset(state, action) {
  const { result } = action;
  const newState = saveDataset(state, action);

  return {
    ...newState,
    lastAddedId: result,
  };
}

function removeDataset(state, action) {
  return {
    ...state,
    lastUpdated: action.receivedAt,
    error: action.error,
    byId: [],
    summaryById: {},
  };
}

function saveDatasetsSummary(state, action) {
  const { result } = action;

  let summaryById = reduce(
    result,
    (acc, summary) => {
      acc[summary.id] = summary;
      return acc;
    },
    {},
  );

  return { ...state, summaryById };
}

function saveDatasetSummary(state, action) {
  const { result } = action;

  let { summaryById } = state;
  if (result) {
    summaryById = { ...summaryById, [result.id]: result };
    return { ...state, summaryById };
  } else {
    return state;
  }
}

function saveDatasetUpdateTime(state, action) {
  const {
    result,
    requestInfo: { id },
  } = action;

  if (result && result.output && result.output.lastModified) {
    return {
      ...state,
      sampleUpdateTimeById: {
        ...state.sampleUpdateTimeById,
        [id]: result.output.lastModified,
      },
    };
  }

  return state;
}

function saveDatasetDoc(state, action) {
  const {
    result,
    requestInfo: { id },
  } = action;

  return {
    ...state,
    docById: {
      [id]: isEmpty(result) ? null : result[0],
    },
  };
}

function deleteDataset(state, action) {
  let {
    requestInfo: { id },
  } = action;
  let deletedDatasetId = id;

  //TODO: Should ideally pass source/derived information in the action/requestInfo to avoid useless computation below

  let newById = filter(state.byId, (sId) => sId !== deletedDatasetId);

  let summaryById = { ...state.summaryById };
  if (has(summaryById, deletedDatasetId)) {
    delete summaryById[deletedDatasetId];
  }

  return {
    ...state,
    lastUpdated: action.receivedAt,
    byId: newById,
    summaryById: summaryById,
    error: null,
  };
}

function deletePipeline(state, action) {
  let {
    requestInfo: { deletedItems },
  } = action;

  let deletedDatasetIds = map(
    filter(deletedItems, (item) => item.type === 'DATA_SET'),
    'data_set_id',
  );

  //TODO: Should ideally pass source/derived information in the action/requestInfo to avoid useless computation below

  let newById = filter(state.byId, (sId) => !deletedDatasetIds.includes(sId));
  let summaryById = { ...state.summaryById };

  forEach(deletedDatasetIds, (deletedDatasetId) => {
    if (has(summaryById, deletedDatasetId)) {
      delete summaryById[deletedDatasetId];
    }
  });

  return {
    ...state,
    lastUpdated: action.receivedAt,
    byId: newById,
    summaryById: summaryById,
    error: null,
  };
}

function copyDatasetToClipboard(state, action) {
  const {
    payload: { id },
  } = action;

  return {
    ...state,
    clipboardDatasetId: id,
  };
}
